import React from 'react';
import { HeadContent } from '@fourthwall/components';
import { StorageLimits } from './modules/StorageLimits';
import { SubscriptionPlan } from './modules/SubscriptionPlan';
export const Plan = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement(HeadContent, { title: "Plan \u2013 Settings" }),
        React.createElement(SubscriptionPlan, null),
        React.createElement(StorageLimits, null)));
};
